/*
 * SOLAYA, kalkulator dietetyczny.
 * Engine quizu z premium UX: step indicator, transitions, summary, brak window.alert.
 * Algorytm scoring placeholder MVP, realny dostarcza zoodietetyk klienta
 * (umowa § 5 ust. 1 lit. d). Wtedy podmieniamy tylko questions_json/products_json
 * w settings bloku, kod nie wymaga zmian.
 */

const DEFAULT_QUESTIONS = [
  {
    id: 'pet_type', type: 'single', title: 'Jakie zwierzę chcesz suplementować?',
    options: [
      { value: 'dog',   label: 'Pies',           meta: 'BARF, sucha, mokra' },
      { value: 'cat',   label: 'Kot',            meta: 'dawkowanie kocie' },
      { value: 'other', label: 'Inne zwierzę',   meta: 'wkrótce' },
    ],
  },
  { id: 'pet_name', type: 'text', title: 'Jak ma na imię?', placeholder: 'np. Reksio', maxlength: 40 },
  { id: 'pet_species_other', type: 'text', title: 'Jakie to zwierzę?', placeholder: 'np. fretka, królik, świnka morska, papuga', maxlength: 60, help: 'Wpisz gatunek pupila.', showIf: { pet_type: 'other' } },
  {
    id: 'diet', type: 'single', title: 'Jaką dietę ma teraz?',
    options: [
      { value: 'barf',  label: 'BARF',           meta: 'surowa mięsna' },
      { value: 'dry',   label: 'Sucha karma',    meta: 'kibble' },
      { value: 'wet',   label: 'Mokra karma',    meta: 'puszki, saszetki' },
      { value: 'mixed', label: 'Dieta mieszana', meta: 'więcej niż jedna forma' },
    ],
  },
  { id: 'weight', type: 'number', title: 'Ile waży Twój pupil?', unit: 'kg', min: 1, max: 100, step: 0.5, placeholder: 'np. 24' },
  {
    id: 'age', type: 'single', title: 'W jakim wieku jest Twój pupil?',
    options: [
      { value: 'puppy',  label: 'Szczeniak', meta: 'do 1 roku' },
      { value: 'adult',  label: 'Dorosły',   meta: '1 – 7 lat' },
      { value: 'senior', label: 'Senior',    meta: '7 lat+' },
    ],
  },
  {
    id: 'size', type: 'single', title: 'Rozmiar rasy?',
    options: [
      { value: 'small',  label: 'Mała',    meta: 'do 10 kg' },
      { value: 'medium', label: 'Średnia', meta: '10 – 25 kg' },
      { value: 'large',  label: 'Duża',    meta: '25 kg+' },
    ],
  },
  {
    id: 'activity', type: 'single', title: 'Poziom aktywności?',
    options: [
      { value: 'low',    label: 'Niska',       meta: 'spacery do 30 min' },
      { value: 'medium', label: 'Umiarkowana', meta: '1 – 2 h dziennie' },
      { value: 'high',   label: 'Wysoka',      meta: 'sport, treningi' },
    ],
  },
  {
    id: 'conditions', type: 'multi', title: 'Czy występują dolegliwości?',
    help: 'Możesz zaznaczyć kilka opcji.',
    options: [
      { value: 'joints',    label: 'Stawy' },
      { value: 'heart',     label: 'Serce' },
      { value: 'allergy',   label: 'Alergie / problemy skórne' },
      { value: 'digestion', label: 'Trawienie' },
      { value: 'none',      label: 'Brak dolegliwości' },
    ],
  },
];

const DEFAULT_PRODUCTS = [
  {
    handle: 'omega-3', variant_id: 0, title: 'Omega-3 Fish Oil', price: '69 zł / 250 ml',
    why: 'Kwasy EPA i DHA z oleju rybnego, fundament suplementacji BARF.',
    core: true,
    weight: { base: 2, per_kg: 0.05 },
    rules: { 'age.senior': 2, 'conditions.joints': 3, 'conditions.heart': 2 },
  },
  {
    handle: 'algi-brunatne', variant_id: 0, title: 'Algi brunatne', price: '37 zł / 250 g',
    why: 'Naturalny jod, wsparcie tarczycy i kondycji sierści.',
    weight: { base: 1, per_kg: 0 },
    rules: { 'conditions.allergy': 3, 'age.puppy': 1 },
  },
  {
    handle: 'drozdze-browarnicze', variant_id: 0, title: 'Drożdże browarnicze', price: '30 zł / 200 g',
    why: 'Witaminy z grupy B i β-glukany, wsparcie odporności.',
    weight: { base: 1, per_kg: 0.02 },
    rules: { 'activity.high': 3, 'activity.medium': 1 },
  },
];

class DogDietCalculator {
  constructor(root) {
    this.root = root;
    this.stage = root.querySelector('.dog-diet-calculator__stage');
    this.progressBar = root.querySelector('.dog-diet-calculator__progress-bar');
    this.progressLabel = root.querySelector('[data-ddc-progress-label]');
    this.toastSlot = root.querySelector('[data-ddc-toast]');

    // ZAWSZE używaj DEFAULT_QUESTIONS — stare settings_data na sklepie ignoruj.
    // Gdy klient w admin chce custom, wtedy odblokowujemy override przez data-questions.
    this.questions = DEFAULT_QUESTIONS;
    this.products = DEFAULT_PRODUCTS;

    this.ctaAdd = root.dataset.ctaAdd || 'Dodaj do koszyka';
    this.ctaRestart = root.dataset.ctaRestart || 'Zacznij od nowa';

    this.state = {
      step: 0,
      answers: {},
    };

    this.initialRender = true;
    this.render();
  }

  isQuestionActive(q) {
    if (!q || !q.showIf) return true;
    return Object.entries(q.showIf).every(([key, val]) => {
      const a = this.state.answers[key];
      if (Array.isArray(val)) return val.includes(a);
      return a === val;
    });
  }

  get activeQuestions() {
    return this.questions.filter((q) => this.isQuestionActive(q));
  }

  get totalSteps() {
    return this.activeQuestions.length;
  }

  get currentQuestion() {
    return this.activeQuestions[this.state.step] || null;
  }

  goNext() {
    if (this.state.step < this.totalSteps - 1) {
      this.state.step += 1;
    } else {
      this.state.step = this.totalSteps;
    }
    this.render();
  }

  goPrev() {
    if (this.state.step > 0) {
      this.state.step -= 1;
      this.render();
    }
  }

  restart() {
    this.state = { step: 0, answers: {} };
    try { localStorage.removeItem('ddc-bundle-expiry'); } catch (e) {}
    this.render();
  }

  startBundleCountdown(el) {
    if (!el) return;
    const KEY = 'ddc-bundle-expiry';
    let expiry;
    try { expiry = parseInt(localStorage.getItem(KEY), 10); } catch (e) { expiry = NaN; }
    const now = Date.now();
    if (!expiry || expiry <= now || expiry > now + 24 * 3600 * 1000) {
      expiry = now + 24 * 3600 * 1000;
      try { localStorage.setItem(KEY, String(expiry)); } catch (e) {}
    }

    const tick = () => {
      const diff = expiry - Date.now();
      if (!el.isConnected) return;
      if (diff <= 0) {
        el.textContent = '00 : 00 : 00';
        el.classList.add('is-expired');
        return;
      }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      el.textContent = `${String(h).padStart(2, '0')} : ${String(m).padStart(2, '0')} : ${String(s).padStart(2, '0')}`;
      requestAnimationFrame(() => setTimeout(tick, 1000));
    };
    tick();
  }

  isAnswered(question) {
    if (question.optional) return true;
    const a = this.state.answers[question.id];
    if (a == null) return false;
    if (question.type === 'multi') return Array.isArray(a) && a.length > 0;
    if (question.type === 'number') return typeof a === 'number' && !Number.isNaN(a);
    if (question.type === 'text') return typeof a === 'string' && a.trim().length > 0;
    return Boolean(a);
  }

  computeRecommendations() {
    const answers = this.state.answers;
    const weight = typeof answers.weight === 'number' ? answers.weight : 0;

    const scored = this.products.map((p) => {
      let base = (p.weight && p.weight.base) || 0;
      if (p.weight && p.weight.per_kg && weight > 0) {
        base += p.weight.per_kg * weight;
      }
      const rules = p.rules || {};
      let ruleScore = 0;
      for (const [key, value] of Object.entries(answers)) {
        if (Array.isArray(value)) {
          for (const v of value) {
            const ruleKey = `${key}.${v}`;
            if (rules[ruleKey]) ruleScore += rules[ruleKey];
          }
        } else {
          const ruleKey = `${key}.${value}`;
          if (rules[ruleKey]) ruleScore += rules[ruleKey];
        }
      }
      return { ...p, score: base + ruleScore, ruleScore };
    });

    // Produkt fundamentowy (core) pokazujemy zawsze. Pozostałe TYLKO gdy faktycznie
    // pasują do odpowiedzi (dopasowana reguła), żeby nie polecać niepotrzebnych.
    return scored
      .filter((p) => p.core || p.ruleScore > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 3);
  }

  buildDogSummary() {
    const a = this.state.answers;
    const parts = [];

    if (typeof a.pet_name === 'string' && a.pet_name.trim()) parts.push(a.pet_name.trim());

    const petMap = { dog: 'pies', cat: 'kot', other: 'inne zwierzę' };
    if (a.pet_type && petMap[a.pet_type]) parts.push(petMap[a.pet_type]);

    const dietMap = { barf: 'dieta BARF', dry: 'sucha karma', wet: 'mokra karma', mixed: 'dieta mieszana' };
    if (a.diet && dietMap[a.diet]) parts.push(dietMap[a.diet]);

    if (typeof a.weight === 'number' && a.weight > 0) parts.push(`${a.weight} kg`);

    const ageMap = { puppy: 'szczeniak', adult: 'dorosły', senior: 'senior' };
    if (a.age && ageMap[a.age]) parts.push(ageMap[a.age]);

    const sizeMap = { small: 'mała rasa', medium: 'średnia rasa', large: 'duża rasa' };
    if (a.size && sizeMap[a.size]) parts.push(sizeMap[a.size]);

    const actMap = { low: 'niska aktywność', medium: 'umiarkowana aktywność', high: 'wysoka aktywność' };
    if (a.activity && actMap[a.activity]) parts.push(actMap[a.activity]);

    if (Array.isArray(a.conditions) && a.conditions.length > 0 && !a.conditions.includes('none')) {
      const condMap = { joints: 'stawy', heart: 'serce', allergy: 'alergie', digestion: 'trawienie' };
      const conds = a.conditions.map((c) => condMap[c]).filter(Boolean);
      if (conds.length) parts.push(conds.join(' + '));
    }

    return parts.join(' · ');
  }

  buildEmailCapture() {
    if (!document.getElementById('ddc-consent-styles')) {
      const style = document.createElement('style');
      style.id = 'ddc-consent-styles';
      style.textContent = '.ddc-email__consent{position:relative;display:grid;grid-template-columns:22px 1fr;gap:12px;align-items:start;margin-top:4px;padding:14px 15px;background:var(--solaya-bg,#fff);border:1px solid var(--solaya-border,#d9d6b8);border-radius:12px;cursor:pointer}.ddc-email__consent:hover{border-color:var(--solaya-sage,#7a8450)}.ddc-email__consent-input{position:absolute;opacity:0;width:1px;height:1px}.ddc-email__consent-mark{display:block;width:20px;min-width:20px;max-width:20px;height:20px;min-height:20px;aspect-ratio:1/1;box-sizing:border-box;border:1.5px solid var(--solaya-sage,#7a8450);border-radius:0;background:var(--solaya-bg,#fff);margin-top:1px;justify-self:start;transition:background .16s ease,border-color .16s ease}.ddc-email__consent-input:checked+.ddc-email__consent-mark{background:var(--solaya-sage,#7a8450);border-color:var(--solaya-sage,#7a8450)}.ddc-email__consent-input:focus-visible+.ddc-email__consent-mark{outline:3px solid rgba(164,86,43,.28);outline-offset:2px}.ddc-email__consent-text{font-size:.76rem;line-height:1.5;color:var(--solaya-muted,#66664f)}.ddc-email__consent-text strong{color:var(--solaya-forest,#3f4222)}.ddc-email__legal a{color:var(--solaya-forest,#3f4222);text-underline-offset:2px}';
      document.head.appendChild(style);
    }

    const box = this.h('aside', { class: 'ddc-email' });

    const head = this.h('div', { class: 'ddc-email__head' });
    head.appendChild(this.h('p', { class: 'ddc-email__eyebrow solaya-mono' }, 'Ostatni krok'));
    head.appendChild(this.h('h4', { class: 'ddc-email__title' }, 'Odbierz plan dla swojego pupila'));
    head.appendChild(this.h('p', { class: 'ddc-email__sub' },
      'Podaj e-mail, a od razu pokażemy rekomendację i wyślemy ją razem z praktycznymi wskazówkami.'));
    box.appendChild(head);

    const form = this.h('form', { class: 'ddc-email__form' });
    const field = this.h('div', { class: 'ddc-email__field' });
    const input = this.h('input', {
      type: 'email', class: 'ddc-email__input', name: 'email',
      placeholder: 'twój@email.pl', autocomplete: 'email', inputmode: 'email',
      required: 'required', 'aria-label': 'Adres e-mail',
    });
    const submit = this.h('button', { type: 'submit', class: 'ddc-btn ddc-btn--primary ddc-email__submit' }, [
      this.h('span', {}, 'Pokaż mój plan'),
      this.svg('arrow-right'),
    ]);
    field.appendChild(input);
    field.appendChild(submit);
    form.appendChild(field);

    const consentId = 'ddc-email-consent-' + Math.random().toString(36).slice(2, 9);
    const consent = this.h('input', {
      type: 'checkbox', id: consentId, name: 'marketing_consent',
      class: 'ddc-email__consent-input', required: 'required',
    });
    const consentText = this.h('span', { class: 'ddc-email__consent-text' }, [
      this.h('strong', {}, 'Tak, chcę otrzymać plan i wiadomości od SOLAYA. '),
      document.createTextNode('Zapisuję się na e-maile z wiedzą o suplementacji, nowościami i ofertami. Zgodę mogę wycofać w każdej chwili.'),
    ]);
    const consentLabel = this.h('label', { class: 'ddc-email__consent', for: consentId }, [
      consent,
      this.h('span', { class: 'ddc-email__consent-mark', 'aria-hidden': 'true' }),
      consentText,
    ]);
    form.appendChild(consentLabel);

    const legal = this.h('p', { class: 'ddc-email__legal' }, [
      document.createTextNode('Administratorem danych jest ASPIREDOM sp. z o.o. Szczegóły: '),
      this.h('a', { href: '/policies/privacy-policy', target: '_blank', rel: 'noopener' }, 'polityka prywatności'),
      document.createTextNode('.'),
    ]);
    form.appendChild(legal);
    box.appendChild(form);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        this.toast('Podaj poprawny adres e-mail.', 'err');
        input.focus();
        return;
      }
      if (!consent.checked) {
        this.toast('Zaznacz zgodę, aby otrzymać plan i wiadomości od SOLAYA.', 'err');
        consent.focus();
        return;
      }
      this.submitEmail(email, box);
    });

    return box;
  }

  async submitEmail(email, box) {
    const a = (this.state && this.state.answers) || {};
    const summary = this.buildDogSummary();
    const recs = this.computeRecommendations();
    const props = {
      pet_name: a.pet_name, pet_type: a.pet_type, diet: a.diet, weight: a.weight, age: a.age,
      size: a.size, activity: a.activity,
      conditions: Array.isArray(a.conditions) ? a.conditions.join(', ') : a.conditions,
      recommendation_summary: summary,
      recommended_products: recs.map((r) => r.title).join(', '),
      recommended_handles: recs.map((r) => r.handle).join(', '),
      marketing_consent: true,
      marketing_consent_source: 'quiz_checkbox',
      marketing_consent_copy_version: '2026-09-02',
      marketing_consent_timestamp: new Date().toISOString(),
    };
    // 1) Subskrybent Shopify (backup/sync, tag quiz-dietetyczny)
    try {
      const body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', 'newsletter, quiz-dietetyczny');
      await fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
    } catch (err) { /* nie blokujemy potwierdzenia */ }

    // 2) Klaviyo: event "Completed Diet Quiz" (uruchamia flow z dopasowaną rekomendacją) + zapis na listę
    const KLAVIYO_COMPANY = 'XTFwi7';
    const KLAVIYO_LIST = 'SYwpHq';
    try {
      // Najpierw zapis zgody na listę, potem event uruchamiający flow.
      await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          profile: { data: { type: 'profile', attributes: {
            email, properties: props,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
          } } },
        }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } } } }),
      });
      await fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_COMPANY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Completed Diet Quiz' } } },
          profile: { data: { type: 'profile', attributes: { email } } },
        } } }),
      });
    } catch (err) { /* nie blokujemy potwierdzenia */ }

    this.state.emailSubmitted = true;
    this.sentEmail = email;
    this.toast('Plan wysłany. Odblokowaliśmy Twoją rekomendację.', 'ok');
    this.render();
  }

  async addToCart(variantId, productTitle, handle) {
    try {
      let id = variantId;
      // Brak ID wariantu w danych quizu? Pobierz aktualny wariant po handle produktu.
      if (!id || id === 0) {
        if (!handle) throw new Error('no_handle');
        const product = await fetch(`/products/${handle}.js`).then((r) => r.json());
        const variants = product.variants || [];
        const v = variants.find((x) => x.available) || variants[0];
        id = v && v.id;
      }
      if (!id) throw new Error('no_variant');
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('cart_add_failed');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      this.toast(`Dodano ${productTitle || 'produkt'} do koszyka.`, 'ok');
      setTimeout(() => { window.location.href = '/cart'; }, 800);
    } catch (err) {
      this.toast('Nie udało się dodać do koszyka, spróbuj ponownie.', 'err');
    }
  }

  toast(message, variant) {
    if (!this.toastSlot) return;
    this.toastSlot.replaceChildren();
    const t = this.h('div', {
      class: `ddc-toast ddc-toast--${variant || 'info'}`,
      role: 'status',
    }, message);
    this.toastSlot.appendChild(t);
    setTimeout(() => t.classList.add('ddc-toast--visible'), 10);
    setTimeout(() => {
      t.classList.remove('ddc-toast--visible');
      setTimeout(() => t.remove(), 300);
    }, 4500);
  }

  personalReason(r) {
    const a = this.state.answers || {};
    const conds = Array.isArray(a.conditions) ? a.conditions : [];
    const MAP = {
      'omega-3': {
        'cond:joints': 'Stawy: kwasy EPA i DHA wyciszają stan zapalny i wspierają ruch.',
        'cond:heart': 'Serce: omega-3 wspiera pracę serca i krążenie.',
        'cond:allergy': 'Skóra i alergie: omega-3 łagodzi stany zapalne skóry i poprawia sierść.',
        'age:senior': 'Senior: wsparcie stawów i kondycji starszego pupila.',
        'default': 'Fundament diety BARF: zdrowa skóra, sierść i stawy.',
      },
      'algi-brunatne': {
        'cond:allergy': 'Skóra i sierść: jod oraz mikroelementy wspierają kondycję skóry.',
        'age:puppy': 'Szczeniak: jod wspiera prawidłowy rozwój i pracę tarczycy.',
        'default': 'Wsparcie tarczycy i uzupełnienie jodu w diecie.',
      },
      'drozdze-browarnicze': {
        'cond:digestion': 'Trawienie: drożdże wspierają mikroflorę i pracę jelit.',
        'act:high': 'Wysoka aktywność: witaminy z grupy B wspierają energię i regenerację.',
        'act:medium': 'Aktywność: witaminy z grupy B wspierają energię i regenerację.',
        'default': 'Witaminy z grupy B i wsparcie naturalnej odporności.',
      },
      'zestaw-starter': {
        'default': 'Komplet trzech suplementów pokrywa większość potrzeb z Twoich odpowiedzi.',
      },
    };
    const m = MAP[r.handle] || {};
    const out = [];
    conds.forEach((c) => { if (m['cond:' + c]) out.push(m['cond:' + c]); });
    if (a.age && m['age:' + a.age]) out.push(m['age:' + a.age]);
    if (a.activity && m['act:' + a.activity]) out.push(m['act:' + a.activity]);
    if (out.length === 0 && m['default']) out.push(m['default']);
    return out.slice(0, 3);
  }

  renderProcessing() {
    if (!document.getElementById('ddc-processing-styles')) {
      const st = document.createElement('style');
      st.id = 'ddc-processing-styles';
      st.textContent = '@keyframes ddc-spin{to{transform:rotate(360deg)}}@keyframes ddc-fade{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}.ddc-processing{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;gap:18px;padding:52px 20px;min-height:300px}.ddc-processing__spinner{width:52px;height:52px;border-radius:50%;border:3px solid rgba(58,60,31,.12);border-top-color:var(--solaya-forest,#3a3c1f);animation:ddc-spin .8s linear infinite}.ddc-processing__title{margin:0;font-family:var(--solaya-font-display,Georgia,serif);font-size:clamp(1.2rem,2.4vw,1.6rem);font-weight:700;color:var(--solaya-forest,#3a3c1f);letter-spacing:-.02em}.ddc-processing__status{margin:0;font-size:.95rem;color:var(--solaya-muted,#6b6b5e);min-height:1.4em;animation:ddc-fade .35s ease both}.ddc-processing__bar{width:min(300px,82%);height:6px;border-radius:999px;background:rgba(58,60,31,.1);overflow:hidden}.ddc-processing__bar-fill{height:100%;width:0;background:var(--solaya-forest,#3a3c1f);border-radius:999px;transition:width 4.9s cubic-bezier(.4,0,.2,1)}.ddc-rec-card__actions{display:flex;flex-direction:column;gap:8px;margin-top:12px}.ddc-rec-card__view{justify-content:center}';
      document.head.appendChild(st);
    }
    const a = this.state.answers || {};
    const petName = (typeof a.pet_name === 'string' && a.pet_name.trim()) ? a.pet_name.trim() : 'Twojego pupila';
    const wrap = this.h('div', { class: 'ddc-processing' });
    wrap.appendChild(this.h('div', { class: 'ddc-processing__spinner', 'aria-hidden': 'true' }));
    wrap.appendChild(this.h('p', { class: 'ddc-processing__title' }, 'Dobieramy rekomendację'));
    const status = this.h('p', { class: 'ddc-processing__status', role: 'status', 'aria-live': 'polite' }, 'Analizujemy odpowiedzi...');
    wrap.appendChild(status);
    const bar = this.h('div', { class: 'ddc-processing__bar' });
    const fill = this.h('div', { class: 'ddc-processing__bar-fill' });
    bar.appendChild(fill);
    wrap.appendChild(bar);
    this.stage.replaceChildren(wrap);

    const steps = [
      'Analizujemy odpowiedzi...',
      `Dopasowujemy suplementy do profilu: ${petName}...`,
      'Liczymy dawki z masy ciała...',
      'Sprawdzamy wskazania i ostrzeżenia...',
      'Przygotowujemy rekomendację...',
    ];
    let i = 0;
    requestAnimationFrame(() => { fill.style.width = '100%'; });
    const timer = setInterval(() => {
      i += 1;
      if (i < steps.length) {
        status.textContent = steps[i];
        status.style.animation = 'none';
        void status.offsetWidth;
        status.style.animation = '';
      }
    }, 950);
    setTimeout(() => {
      clearInterval(timer);
      this.state.processed = true;
      this.render();
    }, 5000);
  }

  render() {
    if (this.totalSteps === 0) {
      this.renderError('Brak pytań w konfiguracji.');
      return;
    }

    const isResultStep = this.state.step >= this.totalSteps;
    const total = this.totalSteps;
    const current = isResultStep ? total : this.state.step + 1;
    const ratio = isResultStep ? 1 : this.state.step / total;

    if (this.progressBar) this.progressBar.style.width = `${Math.round(ratio * 100)}%`;
    if (this.progressLabel) {
      this.progressLabel.textContent = isResultStep
        ? `Wynik · ${total} z ${total}`
        : `Krok ${current} z ${total}`;
    }

    const renderContent = () => {
      if (isResultStep) {
        if (!this.state.processed) { this.renderProcessing(); return; }
        this.renderResult();
      } else {
        this.renderQuestion(this.currentQuestion);
      }
    };

    if (this.initialRender) {
      this.initialRender = false;
      renderContent();
    } else {
      this.transitionStage(renderContent);
    }
  }

  transitionStage(updater) {
    if (!this.stage) { updater(); return; }
    this.stage.classList.add('ddc-stage--leaving');
    setTimeout(() => {
      updater();
      this.stage.classList.remove('ddc-stage--leaving');
      this.stage.classList.add('ddc-stage--entering');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.stage.classList.remove('ddc-stage--entering');
        });
      });
    }, 180);
  }

  renderError(message) {
    this.stage.replaceChildren(this.h('p', { class: 'ddc-error' }, message));
  }

  renderQuestion(q) {
    const wrap = this.h('div', { class: 'ddc-question' });

    if (q.eyebrow || q.id) {
      const eyebrowLabel = q.eyebrow || this.questionTypeLabel(q);
      wrap.appendChild(this.h('p', { class: 'ddc-question__eyebrow solaya-mono' }, eyebrowLabel));
    }

    wrap.appendChild(this.h('h3', { class: 'ddc-question__title' }, q.title));

    if (q.help) {
      wrap.appendChild(this.h('p', { class: 'ddc-question__help' }, q.help));
    }

    if (q.type === 'number') {
      const field = this.h('div', { class: 'ddc-number-field' });
      const input = this.h('input', {
        type: 'number',
        class: 'ddc-input',
        min: q.min ?? '',
        max: q.max ?? '',
        step: q.step ?? 1,
        value: this.state.answers[q.id] ?? '',
        placeholder: q.placeholder || '0',
        inputmode: 'decimal',
      });
      input.addEventListener('input', (e) => {
        const v = parseFloat(e.target.value);
        this.state.answers[q.id] = Number.isNaN(v) ? null : v;
        this.updateActions();
      });
      const unit = q.unit ? this.h('span', { class: 'ddc-number-field__unit solaya-mono' }, q.unit) : null;
      field.appendChild(input);
      if (unit) field.appendChild(unit);
      wrap.appendChild(field);

      if (q.min != null || q.max != null) {
        const hint = this.h('p', { class: 'ddc-question__hint solaya-mono' },
          `Zakres ${q.min ?? 0}${q.unit ? ' ' + q.unit : ''} – ${q.max ?? '∞'}${q.unit ? ' ' + q.unit : ''}`);
        wrap.appendChild(hint);
      }
      setTimeout(() => input.focus(), 200);
    } else if (q.type === 'text') {
      const field = this.h('div', { class: 'ddc-number-field' });
      const input = this.h('input', {
        type: 'text',
        class: 'ddc-input',
        value: this.state.answers[q.id] ?? '',
        placeholder: q.placeholder || '',
        maxlength: q.maxlength ?? 80,
        autocomplete: 'off',
        spellcheck: 'false',
      });
      input.addEventListener('input', (e) => {
        this.state.answers[q.id] = e.target.value;
        this.updateActions();
      });
      field.appendChild(input);
      wrap.appendChild(field);
      setTimeout(() => input.focus(), 200);
    } else {
      const list = this.h('div', { class: 'ddc-options' });
      const isMulti = q.type === 'multi';
      const current = this.state.answers[q.id] ?? (isMulti ? [] : null);

      for (const opt of q.options || []) {
        const id = `ddc-${q.id}-${opt.value}`;
        const checked = isMulti ? current.includes(opt.value) : current === opt.value;

        const input = this.h('input', {
          type: isMulti ? 'checkbox' : 'radio',
          name: `ddc-${q.id}`,
          id,
          value: opt.value,
          ...(checked ? { checked: 'checked' } : {}),
        });

        input.addEventListener('change', () => {
          if (isMulti) {
            const next = new Set(this.state.answers[q.id] || []);
            if (input.checked) next.add(opt.value);
            else next.delete(opt.value);
            this.state.answers[q.id] = Array.from(next);
          } else {
            this.state.answers[q.id] = opt.value;
          }
          this.updateActions();
        });

        const labelText = this.h('span', { class: 'ddc-option__label' }, opt.label);
        const meta = opt.meta ? this.h('span', { class: 'ddc-option__meta' }, opt.meta) : null;
        const mark = this.h('span', { class: 'ddc-option__mark', 'aria-hidden': 'true' });

        const children = [input, mark, labelText];
        if (meta) children.push(meta);

        const label = this.h('label', { class: 'ddc-option', for: id }, children);
        list.appendChild(label);
      }
      wrap.appendChild(list);
    }

    const actions = this.h('div', { class: 'ddc-actions' });

    const prevBtn = this.h(
      'button',
      { type: 'button', class: 'ddc-btn ddc-btn--secondary', 'data-role': 'prev' },
      [
        this.svg('arrow-left'),
        this.h('span', {}, 'Wstecz'),
      ],
    );
    if (this.state.step === 0) prevBtn.setAttribute('disabled', 'disabled');
    prevBtn.addEventListener('click', () => this.goPrev());

    const isLast = this.state.step === this.totalSteps - 1;
    const nextLabel = isLast ? 'Zobacz rekomendacje' : 'Dalej';
    const nextBtn = this.h(
      'button',
      { type: 'button', class: 'ddc-btn ddc-btn--primary', 'data-role': 'next' },
      [
        this.h('span', {}, nextLabel),
        this.svg('arrow-right'),
      ],
    );
    if (!this.isAnswered(q)) nextBtn.setAttribute('disabled', 'disabled');
    nextBtn.addEventListener('click', () => this.goNext());

    actions.appendChild(prevBtn);
    actions.appendChild(nextBtn);
    wrap.appendChild(actions);

    this.stage.replaceChildren(wrap);
  }

  questionTypeLabel(q) {
    const map = {
      pet_type: 'Twój pupil',
      pet_name: 'Imię pupila',
      diet: 'Aktualna dieta',
      weight: 'Waga pupila',
      age: 'Wiek pupila',
      size: 'Rozmiar rasy',
      activity: 'Poziom aktywności',
      conditions: 'Specyfika zdrowotna',
    };
    return map[q.id] || 'Pytanie';
  }

  updateActions() {
    const next = this.stage.querySelector('[data-role="next"]');
    if (!next) return;
    const q = this.currentQuestion;
    if (q && this.isAnswered(q)) next.removeAttribute('disabled');
    else next.setAttribute('disabled', 'disabled');
  }

  renderResult() {
    const a = this.state.answers;
    const isOther = a.pet_type === 'other';

    const wrap = this.h('div', { class: 'ddc-result' });

    if (isOther) {
      const head = this.h('header', { class: 'ddc-result__head' });
      head.appendChild(this.h('p', { class: 'ddc-result__eyebrow solaya-mono' }, 'Status linii'));
      head.appendChild(this.h('h3', { class: 'ddc-result__heading' }, 'Linia dla innych zwierząt, wkrótce'));
      wrap.appendChild(head);

      wrap.appendChild(
        this.h('p', { class: 'ddc-result__empty' },
          'Aktualnie SOLAYA produkuje suplementy dla psów i kotów. Zapisz się do newslettera, żeby dostać informację gdy ruszą kolejne gatunki.'),
      );

      const actions = this.h('div', { class: 'ddc-actions ddc-actions--result' });
      const restart = this.h(
        'button',
        { type: 'button', class: 'ddc-btn ddc-btn--ghost' },
        [ this.svg('refresh'), this.h('span', {}, this.ctaRestart) ],
      );
      restart.addEventListener('click', () => this.restart());
      actions.appendChild(restart);
      wrap.appendChild(actions);

      this.stage.replaceChildren(wrap);
      return;
    }

    const summary = this.buildDogSummary();

    const head = this.h('header', { class: 'ddc-result__head' });
    head.appendChild(this.h('p', { class: 'ddc-result__eyebrow solaya-mono' }, this.state.emailSubmitted ? 'Twoja rekomendacja' : 'Ostatni krok'));
    head.appendChild(this.h('h3', { class: 'ddc-result__heading' }, this.state.emailSubmitted ? 'Zestaw dopasowany do Twojego pupila' : 'Rekomendacja gotowa, odblokuj ją e-mailem'));
    if (summary) {
      head.appendChild(this.h('p', { class: 'ddc-result__summary' }, summary));
    }
    wrap.appendChild(head);

    // BRAMKA E-MAIL: dopóki klient nie poda adresu, NIE pokazujemy produktów.
    if (!this.state.emailSubmitted) {
      wrap.appendChild(this.buildEmailCapture());
      const gateActions = this.h('div', { class: 'ddc-actions ddc-actions--result' });
      const gateRestart = this.h('button', { type: 'button', class: 'ddc-btn ddc-btn--ghost' },
        [ this.svg('refresh'), this.h('span', {}, this.ctaRestart) ]);
      gateRestart.addEventListener('click', () => this.restart());
      gateActions.appendChild(gateRestart);
      wrap.appendChild(gateActions);
      this.stage.replaceChildren(wrap);
      return;
    }

    const recs = this.computeRecommendations();

    if (recs.length === 0) {
      wrap.appendChild(
        this.h('p', { class: 'ddc-result__empty' },
          'Na podstawie odpowiedzi nie udało się dobrać produktów. Skontaktuj się z nami, pomożemy dopasować ręcznie.'),
      );
    } else {
      const grid = this.h('div', { class: 'ddc-recommendations' });
      recs.forEach((r, idx) => {
        const card = this.h('article', { class: 'ddc-rec-card' });
        const main = this.h('div', { class: 'ddc-rec-card__main' });

        const cardHead = this.h('header', { class: 'ddc-rec-card__head' });
        cardHead.appendChild(this.h('span', { class: 'ddc-rec-card__num solaya-mono' },
          String(idx + 1).padStart(2, '0')));
        if (idx === 0) {
          cardHead.appendChild(this.h('span', { class: 'ddc-rec-card__badge solaya-mono' }, 'Najlepszy match'));
        }
        main.appendChild(cardHead);

        main.appendChild(this.h('h4', { class: 'ddc-rec-card__title' }, r.title));
        if (r.why) main.appendChild(this.h('p', { class: 'ddc-rec-card__why' }, r.why));
        main.appendChild(this.h('p', { class: 'ddc-rec-card__price' }, r.price));

        const actions = this.h('div', { class: 'ddc-rec-card__actions' });
        const cta = this.h(
          'button',
          { type: 'button', class: 'ddc-btn ddc-btn--primary ddc-rec-card__cta' },
          [
            this.h('span', {}, this.ctaAdd),
            this.svg('arrow-right'),
          ],
        );
        cta.addEventListener('click', () => this.addToCart(r.variant_id, r.title, r.handle));
        actions.appendChild(cta);
        if (r.handle) {
          actions.appendChild(this.h('a', { class: 'ddc-btn ddc-btn--ghost ddc-rec-card__view', href: '/products/' + r.handle }, 'Zobacz produkt'));
        }
        main.appendChild(actions);
        card.appendChild(main);

        // Spersonalizowane "dlaczego dla Twojego pupila" (na podstawie odpowiedzi w quizie)
        const reasons = this.personalReason(r);
        if (reasons.length) {
          const petName = (typeof a.pet_name === 'string' && a.pet_name.trim()) ? a.pet_name.trim() : 'Twojego pupila';
          const aside = this.h('aside', { class: 'ddc-rec-card__why-you' });
          aside.appendChild(this.h('p', { class: 'ddc-rec-card__why-you-label solaya-mono' }, 'Dlaczego dla ' + petName));
          const ul = this.h('ul', { class: 'ddc-rec-card__why-you-list' });
          reasons.forEach((rs) => ul.appendChild(this.h('li', {}, rs)));
          aside.appendChild(ul);
          card.appendChild(aside);
        }

        grid.appendChild(card);
      });
      wrap.appendChild(grid);

      if (recs.length >= 2) {
        // BARF Starter to staly pakiet 3 suplementow: 119 zl zamiast 136 zl przy zakupie osobno.
        // Cena rzeczywista produktu /products/zestaw-starter, bez sztucznej presji czasowej.
        const STARTER_PRICE = 119;
        const STARTER_REGULAR = 136;

        const bundle = this.h('aside', { class: 'ddc-bundle-prompt' });

        const head = this.h('div', { class: 'ddc-bundle-prompt__head' });
        head.appendChild(this.h('p', { class: 'ddc-bundle-prompt__eyebrow solaya-mono' }, 'BARF Starter'));
        bundle.appendChild(head);

        bundle.appendChild(this.h('p', { class: 'ddc-bundle-prompt__title' },
          'Pakiet 3 suplementów taniej niż osobno'));

        const priceRow = this.h('div', { class: 'ddc-bundle-prompt__prices' });
        priceRow.appendChild(this.h('span', { class: 'ddc-bundle-prompt__price-old' },
          `${STARTER_REGULAR} zł`));
        priceRow.appendChild(this.h('span', { class: 'ddc-bundle-prompt__price-new' },
          `${STARTER_PRICE} zł`));
        priceRow.appendChild(this.h('span', { class: 'ddc-bundle-prompt__save solaya-mono' },
          '−12%'));
        bundle.appendChild(priceRow);

        const bundleCta = this.h('a', {
          href: '/products/zestaw-starter',
          class: 'ddc-btn ddc-btn--bundle',
        }, [
          this.h('span', {}, `Zamów BARF Starter za ${STARTER_PRICE} zł`),
          this.svg('arrow-right'),
        ]);
        bundle.appendChild(bundleCta);

        bundle.appendChild(this.h('p', { class: 'ddc-bundle-prompt__legal' },
          'BARF Starter łączy olej omega-3, algi brunatne i drożdże browarnicze w jednej dostawie, taniej niż kupowane osobno.'));

        wrap.appendChild(bundle);
      }
    }

    if (this.sentEmail) {
      const sent = this.h('aside', { class: 'ddc-email ddc-email--sent' });
      sent.appendChild(this.h('p', { class: 'ddc-email__eyebrow solaya-mono' }, 'Plan w drodze'));
      sent.appendChild(this.h('p', { class: 'ddc-email__sub' },
        `Dopasowaną rekomendację i dawkowanie wysłaliśmy na ${this.sentEmail}.`));
      wrap.appendChild(sent);
    }

    const actions = this.h('div', { class: 'ddc-actions ddc-actions--result' });
    const restart = this.h(
      'button',
      { type: 'button', class: 'ddc-btn ddc-btn--ghost' },
      [
        this.svg('refresh'),
        this.h('span', {}, this.ctaRestart),
      ],
    );
    restart.addEventListener('click', () => this.restart());
    actions.appendChild(restart);
    wrap.appendChild(actions);

    this.stage.replaceChildren(wrap);
  }

  svg(name) {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', '14');
    svg.setAttribute('height', '14');
    svg.setAttribute('viewBox', '0 0 14 14');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(ns, 'path');
    if (name === 'arrow-right') {
      path.setAttribute('d', 'M3 7h8m0 0L7.5 3.5M11 7l-3.5 3.5');
    } else if (name === 'arrow-left') {
      path.setAttribute('d', 'M11 7H3m0 0l3.5-3.5M3 7l3.5 3.5');
    } else if (name === 'refresh') {
      path.setAttribute('d', 'M2 7a5 5 0 019-3M12 7a5 5 0 01-9 3M2 2v3h3M12 12V9H9');
    }
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.6');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  h(tag, attrs = {}, children = []) {
    const el = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
      if (v == null || v === '') continue;
      el.setAttribute(k, v);
    }
    if (typeof children === 'string') {
      el.textContent = children;
    } else if (Array.isArray(children)) {
      for (const c of children) {
        if (c instanceof Node) el.appendChild(c);
        else if (c != null) el.appendChild(document.createTextNode(String(c)));
      }
    }
    return el;
  }
}

const initDogDietCalculators = () => {
  const roots = document.querySelectorAll('.dog-diet-calculator');
  for (const root of roots) {
    if (root.dataset.ddcInit === '1') continue;
    root.dataset.ddcInit = '1';
    new DogDietCalculator(root);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDogDietCalculators);
} else {
  initDogDietCalculators();
}

document.addEventListener('shopify:section:load', initDogDietCalculators);
document.addEventListener('shopify:block:select', initDogDietCalculators);
